const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  root_content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 16,
    borderRadius: 8,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  root_content_text: {
    display: 'flex',
    width: '100%',
    gap: 8,
  },
  root_content_text_row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  root_content_text_column: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  root_content_text_title: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#002E47',
  },
  auto_complete: {
    width: '100%',
    display: 'flex',
    gap: 4,
  },
  auto_complete_max_width: {
    maxWidth: 250,
  },
  icon_button_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
  },
  divider: {
    height: 8,
    display: 'block',
    width: '100%',
  },
})

export default styles
